// extracted by mini-css-extract-plugin
export default {"container":"FeatureImage_container__WEZ-F","image":"FeatureImage_image__73sW1","panoramaButton":"FeatureImage_panoramaButton__jsPIv"};